"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const styles_1 = __importDefault(require("../../styles/styles"));
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const scheduleSlice_1 = require("../../features/schedules/scheduleSlice");
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const utils_1 = require("../../utils/utils");
const eventConstants_1 = require("../../constants/eventConstants");
const analytics_1 = require("../../utils/analytics");
const icon_1 = __importDefault(require("../icon/icon"));
const pressable_1 = __importDefault(require("../pressable/pressable"));
const NextButton = ({ schedule }) => {
    const dispatch = useAppDispatch_1.default();
    const { voipCallStatus } = useAppSelector_1.default((state) => ({
        voipCallStatus: state.communication.voipCallStatus,
    }));
    const callInProgress = utils_1.voipCallInProgress(voipCallStatus);
    const [displayMenu, setDisplayMenu] = react_1.useState(false);
    const handleRecycleSchedule = () => {
        analytics_1.logEvent(eventConstants_1.RECYCLE_SCHEDULE);
        dispatch(scheduleSlice_1.recycleSchedule({ scheduleId: schedule.id }));
    };
    const handleCompleteSchedule = async () => {
        await dispatch(scheduleSlice_1.resetScheduleState());
        await dispatch(scheduleSlice_1.completeSchedule({ scheduleId: schedule.id }));
        analytics_1.logEvent(eventConstants_1.CONFIRM_NEXT_BUTTON_PRESS);
        dispatch(scheduleSlice_1.getNextSchedule());
    };
    const anchor = (react_1.default.createElement(pressable_1.default, { disabled: callInProgress, onPress: () => setDisplayMenu(true), style: [styles_1.default.flexDirectionRow, styles_1.default.alignCenterCenter], eventName: eventConstants_1.NEXT_SCHEDULE_PRESS },
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(react_native_paper_1.Title, { style: styles_1.default.textColorBlue }, ` Next `)),
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
            react_1.default.createElement(icon_1.default, { icon: free_solid_svg_icons_1.faArrowRight }))));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_native_paper_1.Menu, { visible: displayMenu, onDismiss: () => setDisplayMenu(false), anchor: anchor },
            react_1.default.createElement(react_native_paper_1.Menu.Item, { title: "Reattempt", onPress: handleRecycleSchedule, key: "reattempt" }),
            react_1.default.createElement(react_native_paper_1.Menu.Item, { title: "Complete", onPress: handleCompleteSchedule, key: "complete" }))));
};
exports.default = NextButton;
